module.exports = __webpack_public_path__ + "static/media/BasierCircle-Regular.efa7ad5f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-Regular.woff
// module id = 6540
// module chunks = 1